import IntlMessages from "../../../../util/IntlMessages";
import { Icon_CloseCircle } from "../../../BP2Components/Icons/icons";
import "./FormNotAvailable.less";

const FormNotAvailable = ({ formId }) => {
   return (
      <div className="form-not-available">
         <Icon_CloseCircle fill="none" stroke="#F97316" className="form-not-available__icon" />
         <h3 className="form-not-available__title">
            <IntlMessages id="form.formNotAvailableTitle" />
         </h3>
         <p className="form-not-available__message">
            <IntlMessages id="form.formNotAvailableMessage" />
            (Form ID: <b>{formId}</b>)
         </p>
      </div>
   );
};

export default FormNotAvailable;
